import { ClipLoader } from "react-spinners";
import { getPrimaryColour } from "../utils/getPrimaryColour";

export default function Spinner() {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <ClipLoader color={getPrimaryColour()} size={48} />
    </div>
  );
}
